import { useEffect, useState } from 'react';
import { Users, Search } from 'lucide-react';
import { api } from '../lib/api';
import { VerifiedBadge } from './VerifiedBadge';

const ROLES = [
  { v: '', label: 'Tous' },
  { v: 'buyer', label: 'Acheteurs' },
  { v: 'seller', label: 'Boutiques' },
  { v: 'admin', label: 'Admins' },
];

export const UsersPanel = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [role, setRole] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const id = setTimeout(async () => {
      setLoading(true);
      try { const { data } = await api.get('/admin/users', { params: { q, role } }); setItems(data); } catch {}
      setLoading(false);
    }, 300);
    return () => clearTimeout(id);
  }, [q, role]);

  return (
    <section className="card-elev rounded-2xl p-5" data-testid="users-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h2 className="font-display text-xl font-bold flex items-center gap-2"><Users className="h-5 w-5 text-rose-400" />Utilisateurs <span className="text-slate-500 text-sm font-normal" data-testid="users-count">({items.length})</span></h2>
        <div className="flex flex-wrap items-center gap-2">
          <div className="relative">
            <Search className="h-4 w-4 absolute left-2.5 top-2.5 text-slate-500" />
            <input data-testid="users-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nom, e-mail, téléphone, boutique…"
              className="pl-8 pr-3 py-2 text-sm rounded-xl bg-slate-900/60 border border-slate-800 focus:border-rose-500 outline-none w-64" />
          </div>
          <div className="flex gap-1">
            {ROLES.map((r) => (
              <button key={r.v} type="button" data-testid={`users-filter-${r.v || 'all'}`} onClick={() => setRole(r.v)}
                className={`px-3 py-1.5 text-xs rounded-full border transition-colors ${role === r.v ? 'bg-rose-500/20 border-rose-500/50 text-rose-200' : 'border-slate-800 text-slate-400 hover:text-slate-200'}`}>
                {r.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="overflow-x-auto pretty-scroll">
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500 text-left">
            <tr><th className="py-2 pr-3">Nom</th><th className="py-2 pr-3">Identifiant</th><th className="py-2 pr-3">Rôle</th><th className="py-2 pr-3">Boutique</th><th className="py-2 pr-3">Inscription</th><th className="py-2 text-right">Commandes</th></tr>
          </thead>
          <tbody>
            {!loading && items.length === 0 && <tr><td colSpan={6} className="py-4 text-slate-500">Aucun utilisateur trouvé.</td></tr>}
            {items.map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`} className="border-t border-slate-800/70 hover:bg-slate-900/40">
                <td className="py-2 pr-3 font-bold flex items-center gap-1.5">{u.name || '—'}{u.verified && <VerifiedBadge verified testId={`user-verified-${u.user_id}`} />}</td>
                <td className="py-2 pr-3 text-slate-300">{u.email || u.phone || '—'}{u.email && u.phone ? <span className="text-slate-500 text-xs block">{u.phone}</span> : null}</td>
                <td className="py-2 pr-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${u.role === 'seller' ? 'bg-amber-500/20 text-amber-300' : u.role === 'admin' ? 'bg-rose-500/20 text-rose-300' : 'bg-sky-500/20 text-sky-300'}`}>
                    {u.role === 'seller' ? 'Boutique' : u.role === 'admin' ? 'Admin' : 'Acheteur'}
                  </span>
                  {u.suspended && <span className="ml-1 text-xs text-rose-400">suspendu</span>}
                </td>
                <td className="py-2 pr-3 text-slate-300">{u.shop_name || '—'}</td>
                <td className="py-2 pr-3 text-slate-400 text-xs">{u.created_at ? new Date(u.created_at).toLocaleDateString() : '—'}</td>
                <td className="py-2 text-right font-mono-num text-amber-400">{u.orders_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
